import { FC } from 'react'
import { Link } from 'react-router-dom'

export interface BreadcrumbProps {
  title: string
  path: string
  className?: { link: string; title: string; last_title: string }
}

const Breadcrumb: FC<BreadcrumbProps> = ({ title, path, className }) => {
  const currentPath = window.location.pathname
  const isLast = currentPath.localeCompare(path.split('/?')[0]) === 0
  if (isLast) return <span className={`${className?.last_title} last-breadcrumb breadcrumb-item`}>{title}</span>
  return (
    <Link to={path} title={title} className={`${className?.link} breadcrumb-item`}>
      <div className={`${className?.title} breadcrumb-item__title`}>{title}</div>
      <span>/</span>
    </Link>
  )
}

export default Breadcrumb
